import React from 'react';
import { Card } from 'antd';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip as RechartsTooltip,
  Legend,
  ResponsiveContainer,
} from 'recharts';

interface MonthProfit {
  month: number;
  totalRevenue: number;
  totalExpense: number;
  netProfit: number;
}

interface ChartCardProps {
  title: string;
  data: any[];
  loading?: boolean;
}

const ChartCard: React.FC<ChartCardProps> = ({
  title,
  data,
  loading = false,
}) => {
  const formatCurrency = (value: number) => {
    return new Intl.NumberFormat('vi-VN', {
      style: 'currency',
      currency: 'VND',
    }).format(value);
  };

  const CustomTooltip = ({ active, payload, label }: any) => {
    if (active && payload && payload.length) {
      return (
        <div className="bg-white p-3 border border-gray-200 rounded shadow-lg">
          <p className="font-semibold">{`Tháng ${label}`}</p>
          {payload.map((entry: any, index: number) => (
            <p key={index} style={{ color: entry.color }}>
              {`${entry.name}: ${formatCurrency(entry.value)}`}
            </p>
          ))}
        </div>
      );
    }
    return null;
  };

  return (
    <Card
      title={
        <div className="flex items-center">
          <span>{title}</span>
        </div>
      }
      loading={loading}
      className="shadow-md"
    >
      <ResponsiveContainer width="100%" height={400}>
        <BarChart
          data={data}
          margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="month" />
          <YAxis tickFormatter={formatCurrency}
            width={100} />
          <RechartsTooltip content={<CustomTooltip />} />
          <Legend />
          <Bar dataKey="totalRevenue" name="Doanh thu" fill="#3f8600" />
          <Bar dataKey="totalExpense" name="Chi phí" fill="#cf1322" />
          <Bar dataKey="netProfit" name="Lợi nhuận" fill="#1890ff" />
        </BarChart>
      </ResponsiveContainer>
    </Card>
  );
};

export default ChartCard;
